module.exports = __webpack_public_path__ + "media/img/decorations/decoration_left-c929385a21d9258b513794456afc0146.svg";